export const ALL_FAMILY_MEMBERS_IN_LIFE_ENGLISH_QUESTION_ID =
    "d63a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHO_DO_YOU_LIVE_WITH_ENGLISH_QUESTION_ID =
    "d73a79ed-b03a-4be9-a14f-424761ec9bc6";
export const PARENT_DESCRIBE_THEIR_MOOD_ENGLISH_QUESTION_ID =
    "d93a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_ABOUT_SIBLINGS_ENGLISH_QUESTION_ID =
    "d83a79ed-b03a-4be9-a14f-424761ec9bc6";
export const EXPERIENCED_DEATH_IN_THE_FAMILY_ENGLISH_QUESTION_ID =
    "466bb39e-87b7-4cce-a3de-4db60a7c014e";
export const SERIOUSLY_ILL_FAMILY_MEMBER_ENGLISH_QUESTION_ID =
    "476bb39e-87b7-4cce-a3de-4db60a7c014e";
export const WHO_CAN_YOU_COUNT_ON_IN_THE_FAMILY_ENGLISH_QUESTION_ID =
    "db3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const ARE_THERE_PEOPLE_OUTSIDE_YOU_CAN_COUNT_ON_ENGLISH_QUESTION_ID =
    "dc3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const PEOPLE_I_CAN_COUNT_ON_LIFE_AREA_ID =
    "dd3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const RACE_SKIN_COLOR_RELIGION_ENGLISH_QUESTION_ID =
    "486bb39e-87b7-4cce-a3de-4db60a7c014e";
export const SEEING_MENTAL_HEALTH_PROFESSIONALLY_ENGLISH_QUESTION_ID =
    "496bb39e-87b7-4cce-a3de-4db60a7c014e";
export const HAPPY_OVERALL_ENGLISH_QUESTION_ID = "de3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_MAKES_YOU_HAPPY_ENGLISH_QUESTION_ID =
    "df3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_COULD_MAKE_YOU_HAPPIER_ENGLISH_QUESTION_ID =
    "e03a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_TIRED_DURING_SCHOOL_DAY_ENGLISH_QUESTION_ID =
    "e13a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_MAKES_YOU_TIRED_ENGLISH_QUESTION_ID =
    "e23a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_MAKES_YOU_LESS_TIRED_ENGLISH_QUESTION_ID =
    "e33a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_ARE_YOU_DOING_ACADEMICALLY_ENGLISH_QUESTION_ID =
    "e43a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_ARE_YOU_DOING_SOCIALLY_ENGLISH_QUESTION_ID =
    "e63a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_CAN_YOU_IMPROVE_ACADEMICALLY_ENGLISH_QUESTION_ID =
    "e53a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HAVE_YOUR_PEERS_HURT_YOU_ENGLISH_QUESTION_ID =
    "e83a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_DID_YOU_PEERS_DO_TO_HURT_YOU_ENGLISH_QUESTION_ID =
    "e93a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_TIRED_ON_THE_WEEKEND_ENGLISH_QUESTION_ID =
    "ea3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_MAKES_YOU_TIRED_ON_THE_WEEKEND_ENGLISH_QUESTION_ID =
    "07600418-5210-4186-898a-a4c3fe107fe4";
export const WHAT_COULD_YOU_CHANGE_TO_BE_LESS_TIRED_ON_THE_WEEKEND_ENGLISH_QUESTION_ID =
    "eb3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_SAD_ARE_YOU_ENGLISH_QUESTION_ID =
    "ec3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_MAKES_YOU_SAD_ENGLISH_QUESTION_ID =
    "ed3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const DO_YOU_HAVE_INTERESTS_ENGLISH_QUESTION_ID =
    "ee3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const IS_THERE_ANY_THING_THAT_STOPS_YOU_FROM_YOUR_INTERESTS_ENGLISH_QUESTION_ID =
    "f03a79ed-b03a-4be9-a14f-424761ec9bc6";
export const DO_YOU_HAVE_A_STOMACH_ACHE_ENGLISH_QUESTION_ID =
    "f13a79ed-b03a-4be9-a14f-424761ec9bc6";
export const FREQUENCY_OF_HEADACHES_ENGLISH_QUESTION_ID =
    "f23a79ed-b03a-4be9-a14f-424761ec9bc6";
export const CHECK_ALL_THAT_APPLY_ENGLISH_QUESTION_ID =
    "f33a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HARD_TO_CONCENTRATE_ENGLISH_QUESTION_ID =
    "f43a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HARD_TO_CONCENTRATE_DESCRIPTION_ENGLISH_QUESTION_ID =
    "f53a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_NERVOUS_ENGLISH_QUESTION_ID = "f63a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOW_NERVOUS_DESCRIPTION_ENGLISH_QUESTION_ID =
    "f73a79ed-b03a-4be9-a14f-424761ec9bc6";
export const CHANGE_TO_BE_LESS_NERVOUS_ENGLISH_QUESTION_ID =
    "f83a79ed-b03a-4be9-a14f-424761ec9bc6";
export const GREATEST_WORRY_ENGLISH_QUESTION_ID =
    "f93a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WORRY_STOPPED_SOCIALIZATION_ENGLISH_QUESTION_ID =
    "fa3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const HOPELESSNESS_ENGLISH_QUESTION_ID = 'f7d6e514-6066-f011-8dca-000d3a0d3994'
export const SUICIDAL_ENGLISH_QUESTION_ID = "fb3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const SUICIDAL_DESCRIPTION_ENGLISH_QUESTION_ID =
    "fc3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_ENERGIZES_YOU_ENGLISH_QUESTION_ID =
    "fd3a79ed-b03a-4be9-a14f-424761ec9bc6";
export const WHAT_STRENGTHS_GIFTS_TALENTS_ENGLISH_QUESTION_ID =
    "fe3a79ed-b03a-4be9-a14f-424761ec9bc6";
